import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { GlobalAction, VideoDeletesState } from '.';
import { videoDeletesReducer } from './videoDeletesReducer';

type Props = {
  children: ReactNode;
};

type ContextProps = {
  state: VideoDeletesState;
  dispatch: React.Dispatch<GlobalAction>;
};

const VideoDeletesContext = createContext({} as ContextProps);

const initialState: VideoDeletesState = {
  videoDelete: {},
  loading: false,
};

export const VideoDeletesContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(videoDeletesReducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return (
    <VideoDeletesContext.Provider value={value}>
      {children}
    </VideoDeletesContext.Provider>
  );
};

export const useVideoDeletesContext = () => useContext(VideoDeletesContext);
